module.exports = __webpack_public_path__ + "img/banner-01.ce441964.jpg";